module.exports = __webpack_public_path__ + "img/holotrichia-oblita.b612e7f8.jpg";